<template>
  <section>
    <el-form class="form_cls" :inline="true" v-if="buttonList != null && buttonList.length > 0" :model="filters" @submit.native.prevent>
      <el-form-item label="">
        <el-input style="width: 160px" v-model="filters.name" placeholder="医院名称"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-select style="width: 160px" v-model="filters.product" placeholder="产品品类">
          <el-option label="景深延长(散+非散)" value="景深延长(散+非散)"></el-option>
          <el-option label="三焦点(散+非散)" value="三焦点(散+非散)"></el-option>
          <el-option label="双焦(散+非散)" value="双焦(散+非散)"></el-option>
          <el-option label="单焦非散" value="单焦非散"></el-option>
          <el-option label="单焦散光" value="单焦散光"></el-option>
        </el-select>
        <!-- <el-input style="width: 160px" v-model="filters.product" placeholder="产品品类"></el-input> -->
      </el-form-item>
      <el-form-item label="">
        <el-date-picker
          style="width: 160px"
          v-model="filters.startDate"
          format="yyyy-MM"
          value-format="yyyy-MM"
          type="month"
          placeholder="开始月份"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker
          style="width: 160px"
          v-model="filters.endDate"
          format="yyyy-MM"
          value-format="yyyy-MM"
          type="month"
          placeholder="结束月份"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="filters.area" @change="getRegionList" style="width: 160px" placeholder="大区">
          <el-option v-for="item in area_list" :key="item.id" :label="item.regionName" :value="item.regionName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="">
        <el-select v-model="filters.city" style="width: 160px" placeholder="小区">
          <el-option v-for="item in city_list" :key="item.id" :label="item.subRegionName" :value="item.subRegionName"></el-option>
        </el-select>
      </el-form-item>
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button
          :type="
            item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'
          "
          v-if="!item.IsHide"
          @click="callFunc(item)"
        >
          {{ item.name }}
        </el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div class="table_top_div">
      <div>
        <el-table
          border
          :max-height="tableHeight"
          :data="tabel_list"
          header-cell-class-name="header_cell_name"
          :cell-style="{ 'text-align': 'center' }"
          highlight-current-row
          :header-cell-style="{ 'text-align': 'center', color: '#6170d7', backgroundColor: '#F5F7FA', padding: ' 7px 0 !important' }"
          @current-change="selectCurrentRow"
          v-loading="listLoading"
          @selection-change="selsChange"
          style="width: 100%"
        >
          <el-table-column prop="zcnCode" label="医院编号" width="120"></el-table-column>
          <el-table-column prop="name" label="医院名称"></el-table-column>
          <el-table-column prop="salesRepresentative" label="填写人姓名"></el-table-column>
          <el-table-column prop="area" label="大区" width="60"></el-table-column>
          <el-table-column prop="regionalManager" label="大区经理"></el-table-column>
          <el-table-column prop="city" label="小区" width="60"></el-table-column>
          <el-table-column prop="lmManager" label="小区经理"></el-table-column>
          <el-table-column prop="productCategory" label="产品品类"></el-table-column>
          <el-table-column prop="quantity" label="数量" width="80"></el-table-column>
          <el-table-column prop="actualMonth" label="手术月份"></el-table-column>
          <el-table-column prop="reportDate" label="提交时间"></el-table-column>
        </el-table>
      </div>
      <!--工具条-->
      <div class="toolbar_div">
        <el-col :span="24" class="toolbar">
          <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
          <el-pagination
            :background="true"
            layout="prev, pager, next"
            @current-change="handleCurrentChange"
            :page-size="50"
            :total="total"
            style="float: right"
          ></el-pagination>
        </el-col>
      </div>
    </div>
  </section>
</template>

<script>
import util from '../../../util/date'
import { cataractnnvmp_getmonthlysurgerydata, dashboard_getregionsbylevel, cataractnnvmp_getmonthlysurgeryexport } from '../../api/api'
import { getButtonList } from '../../promissionRouter'
import { quillEditor } from 'vue-quill-editor'
import { uploadfiles } from '@/uploadfiles'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Toolbar from '../../components/Toolbar'

export default {
  components: { Toolbar, quillEditor },
  data() {
    return {
      city_list: [],
      area_list: [],
      isMobile: false,
      tableHeight: 0,
      buttonList: [],
      editorOption: {
        // editorOption里是放图片上传配置参数用的，例如：
        action: '/images/Upload/Pic', // 必填参数 图片上传地址
        methods: 'post', // 必填参数 图片上传方式
        token: this.token, // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
        // name: 'upload_file',  // 必填参数 文件的参数名
        // size: 500,  // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
        // accept: 'multipart/form-data, image/png, image/gif, image/jpeg, image/bmp, image/x-icon,image/jpg'  // 可选 可上传的图片格式
      },
      token: '',
      addLoading: false,
      editFormRules: {
        html: [{ required: true, message: '请填写', trigger: 'blur' }],
        type: [{ required: true, message: '请填写', trigger: 'blur' }],
      },
      currentRow: null,
      filters: {
        pageSize: 50,
        city: '',
      },
      tabel_list: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
    }
  },
  methods: {
    getRegionList(value) {
      const selectedOptions = this.area_list.filter((option) => option.regionName === value)
      this.city_list = selectedOptions[0].subRegions
      this.filters.city = ''
    },
    async dashboard_getregionsbylevel() {
      const { data } = await dashboard_getregionsbylevel()
      this.area_list = data.data.regions
    },
    selectCurrentRow(val) {
      this.currentRow = val
    },
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    handleCurrentChange(val) {
      this.page = val
      this.getModules()
    },
    getModules_search() {
      this.page = 1
      this.getModules()
    },
    async ExportAccount() {
      let para = this.filters
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      const { data, headers } = await cataractnnvmp_getmonthlysurgeryexport(para)
      uploadfiles(data, headers, this.loading)
    },
    //获取用户列表
    getModules() {
      let para = this.filters
      para.page = this.page
      this.listLoading = true
      cataractnnvmp_getmonthlysurgerydata(para).then((res) => {
        this.total = res.data.dataCount
        this.tabel_list = res.data.data
        console.log(this.tabel_list)
        this.listLoading = false
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
  },
  mounted() {
    this.isMobile = window.innerWidth <= 767
    this.$nextTick(() => {
      this.$nextTick(() => {
        if (this.isMobile) {
          this.tableHeight = window.innerHeight - 380
        } else {
          this.tableHeight = window.innerHeight - 230
        }
      })
    })
    this.getModules()
    this.dashboard_getregionsbylevel()
    let tokenStr = window.localStorage.Token
    this.token = {
      Authorization: 'Bearer ' + tokenStr,
    }
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : []
    this.buttonList = getButtonList(this.$route.path, routers)
    console.log(this.buttonList)
  },
}
</script>

<style scoped></style>
